import { useTranslation } from "react-i18next";

import { ConfirmationDialog } from "@/components/ConfirmationDialog";

export interface ILogoutConfirmationModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export const LogoutConfirmationModal = ({
  open,
  onOpenChange,
  onConfirm,
}: ILogoutConfirmationModalProps): JSX.Element => {
  const { t } = useTranslation("common");

  return (
    <ConfirmationDialog
      open={open}
      onOpenChange={onOpenChange}
      content={{
        title: t("logout_confirmation.title"),
        description: t("logout_confirmation.description"),
        cancelText: t("logout_confirmation.cancel"),
        confirmText: t("logout_confirmation.confirm"),
      }}
      actions={{
        onConfirm,
      }}
      testIdPrefix="logout"
    />
  );
};
